module.exports = __webpack_public_path__ + "static/media/bg-home.0d0072df.jpg";